import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { ServiciosAdicionalesView, validarServiciosAdicionales } from "../adicionales/view";
import { DestinoSucursal } from "../destinosucursal";
import { validarCoberturaEAD, validarFolioPP, arreglarGuiaPP, arreglarGuiaPPNuevo } from "../logic";
import { observeResource } from "kea-resource";
import { EsZonaExtRx } from "../eszonaext";
import { FolioGuiaPP } from "../guiapp";

type Entity = models.SobreDocumentacion;
export interface Props extends kea.ModalProps<Entity, boolean, boolean> {
}

/**
* Modal de edición para un SobreDocumentacion
*/
export class SobreDocumentacionEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = () => validation.getErrors(this.rules, this.props.value);
    esFolioGuiaPP = (props: Props) => !!props.value.FolioGuiaPP;

    getField = formfields(() => this.props, () => this.errors());

    onFolioPPChange = async (folioPP: string) => {
        const value = this.value(this.props);
        const cambio: Partial<Entity> = { FolioGuiaPP: folioPP };
        const nuevo = { ...value, ...cambio } as Entity;
        var next = await arreglarGuiaPPNuevo(nuevo, models.TipoServicio.Paquete);
        this.props.onChange(next);
    }

    get rules(): validation.Rules<Entity> {
        return {
            Cantidad: validation.and(validation.required, validation.integer, validation.range(1)),
            IdDireccionDestino: validation.required,
            IdContenidoSobre: validation.required,
            IdSucursalDestino: validation.required,
            ServiciosAdicionales: (x, key) => validation.subrule<models.ServiciosAdicionales, Entity>(y => validarServiciosAdicionales(y, x))(x, key),
            FolioGuiaPP: x => validarFolioPP(x.FolioGuiaPP, models.TipoServicio.Sobre)
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    puedeModificarRecoleccion = (props: Props) => props.params;

    servAdic = (x: Props) => x.value.ServiciosAdicionales;
    idDireccionDestino = (x: Props) => x.value.IdDireccionDestino;
    idSucursalDestino = (x: Props) => x.value.IdSucursalDestino;
    esZonaExtendida = createSelectorRx(
        this.servAdic,
        this.idSucursalDestino,
        this.idDireccionDestino,
        (servAdic, idSucDest, idDireccionDestino) =>
            observeResource(resources.Documentacion.EsZonaExtendida, servAdic, idSucDest, idDireccionDestino));


    render() {
        const value = this.props.value;
        const esFolioGuiaPP = this.esFolioGuiaPP(this.props);

        const getField = this.getField;
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const ServicioAdicional = getField(ServiciosAdicionalesView);
        const Contenido = getField(selectores.ContenidoSobre);
        const puedeModificarRecoleccion = this.puedeModificarRecoleccion(this.props);
        const esZonaExtendida = this.esZonaExtendida(this.props);

        const err = validation.hasError(this.errors());
        const GuiaPP = getField(FolioGuiaPP);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={err} />]}
                onClose={this.onCerrar}
                title="Sobre"
            >
                {kea.autogrid(6, [
                    <div>
                        <kea.Panel title="General">
                            {kea.autogrid(6, [
                                <Contenido field="IdContenidoSobre" label="Contenido" />,
                                <Number field="Cantidad" readonly={!!value.FolioGuiaPP} />,
                                <Text field="Observaciones" />,
                                <GuiaPP field="FolioGuiaPP" label="Guia PP" onChange={this.onFolioPPChange} />
                            ])}
                        </kea.Panel>
                        <EsZonaExtRx value={esZonaExtendida} />
                        <ServicioAdicional field="ServiciosAdicionales" tipo="sobre" servicio={value} puedeModificarRecoleccion={puedeModificarRecoleccion} esFolioGuiaPP={esFolioGuiaPP} />
                    </div>,
                    <div>
                        <DestinoSucursal value={this.props.value} onChange={this.props.onChange} />
                    </div>
                ])}
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/sobres/edit.tsx